"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XHRClient = void 0;

var base_js_1 = require("./base.js");

var utils_js_1 = require("../../utils.js");

var XHRResponse = /*#__PURE__*/function (_base_js_1$BaseRespon) {
  (0, _inherits2.default)(XHRResponse, _base_js_1$BaseRespon);

  var _super = _createSuper(XHRResponse);

  /**
   * BaseResponse facade for XMLHttpRequest
   * @param {XMLHttpRequest} xhr
   * @param {ArrayBuffer} data
   */
  function XHRResponse(xhr, data) {
    var _this;

    (0, _classCallCheck2.default)(this, XHRResponse);
    _this = _super.call(this);
    _this.xhr = xhr;
    _this.data = data;
    return _this;
  }

  (0, _createClass2.default)(XHRResponse, [{
    key: "status",
    get: function get() {
      return this.xhr.status;
    }
  }, {
    key: "getHeader",
    value: function getHeader(name) {
      return this.xhr.getResponseHeader(name);
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }]);
  return XHRResponse;
}(base_js_1.BaseResponse);

var XHRClient = /*#__PURE__*/function (_base_js_1$BaseClient) {
  (0, _inherits2.default)(XHRClient, _base_js_1$BaseClient);

  var _super2 = _createSuper(XHRClient);

  function XHRClient() {
    (0, _classCallCheck2.default)(this, XHRClient);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(XHRClient, [{
    key: "constructRequest",
    value: function constructRequest(headers, signal) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', _this2.url);
        xhr.responseType = 'arraybuffer';

        for (var _i = 0, _Object$entries = Object.entries(headers); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          xhr.setRequestHeader(key, value);
        } // hook signals


        xhr.onload = function () {
          var data = xhr.response;
          resolve(new XHRResponse(xhr, data));
        };

        xhr.onerror = reject;

        xhr.onabort = function () {
          return reject(new utils_js_1.AbortError('Request aborted'));
        };

        xhr.send();

        if (signal) {
          if (signal.aborted) {
            xhr.abort();
          }

          signal.addEventListener('abort', function () {
            return xhr.abort();
          });
        }
      });
    }
  }, {
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _ref,
            headers,
            signal,
            response,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, signal = _ref.signal;
                _context2.next = 3;
                return this.constructRequest(headers, signal);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);
  return XHRClient;
}(base_js_1.BaseClient);

exports.XHRClient = XHRClient;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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